"use client";
import { Control, Controller, UseFormClearErrors } from "react-hook-form";
import { useFetchDriversByWarehouse } from "../../../apis/driverApis";
import { useWarehouseListData } from "../../../apis/warehouseApi";
import FileUploader from "../../../components/common/FileUploader";
import Input from "../../../components/Input";
import SelectInput from "../../../components/Select";
import { IconCar } from "@tabler/icons-react";
import NewinputField from "../../../components/NewInput";
import NewSelectInput from "../../../components/NewSelectInput";
import { T } from "../../../context/LanguageContext";

type AssignModalProps = {
  register?: any;
  errors?: any;
  setValue: (name: string, value: any) => void;
  watch: (name: string) => any;
  // clearErrors?: (name?: string) => void;
  clearErrors?: UseFormClearErrors<any>;
  control: Control<any>;
  setMode?: (mode: string) => void;
};

const SectionHeader = ({ icon: Icon, title }: { icon: any; title: string }) => (
  <div className="flex items-center gap-2 border-b border-[#FBD037]/30 pb-2 mb-3">
    <div className="p-1.5 rounded-lg bg-[#FBD037]/20">
      <Icon size={16} className="text-[#212121]" stroke={1.5} />
    </div>
    <p className="text-[#212121]/80 uppercase text-[11px] font-bold tracking-wide">
      <T>{title}</T>
    </p>
  </div>
);

const AssignModal: React.FC<AssignModalProps> = ({
  register,
  errors,
  setValue,
  watch,
  clearErrors,
  control,
}) => {
  const { data: warehouses } = useWarehouseListData();
  const warehousesId = watch("warehousesId");
  const driverId = watch("driverId");
  const { data: drivers } = useFetchDriversByWarehouse(warehousesId);
  return (
     <div className="group  rounded-2xl bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl border border-[#D2D2D2]/70 p-4 transition-all duration-300 space-y-3">
          <div className="absolute inset-0 rounded-3xl bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />
          <SectionHeader icon={IconCar} title="Assign" />
      <div className="grid grid-cols-3 gap-4">
        <NewSelectInput
          name="warehousesId"
          label="Select Warehouse"
          selectOptions={
            warehouses?.warehouses?.map((w: any) => ({
              id: w?.id,
              value: w?.id,
              text: w?.name,
            })) || []
          }
          register={register}
          clearErrors={clearErrors}
          validation={{ required: "Warehouse is required" }}
          error={errors.warehousesId}
          disabled={!warehouses || warehouses?.warehouses?.length === 0}
          value={warehousesId}
          setValue={(val: string) => {
            setValue("warehousesId", val);
            setValue("driverId", "");
          }}
        />

        {/* Driver Select */}
        <NewSelectInput
          name="driverId"
          label="Select Driver"
          selectOptions={
            drivers?.map((d: any) => ({
              id: d?.id,
              value: d?.id,
              text: d?.name,
            })) || []
          }
          register={register}
          clearErrors={clearErrors}
          validation={{ required: "Driver is required" }}
          error={errors.driverId}
          disabled={!drivers || drivers?.length === 0}
          value={driverId}
          setValue={(val: string) => setValue("driverId", val)}
        />
        <NewinputField
          title="Odometer"
          name="lastOdometer"
          placeholder="1002 km"
          register={register}
          error={errors.lastOdometer}
          validation={{ required: "Odometer is required" }}
        />

        <Controller
          name="inspectionPaper"
          rules={{
            required: "Inspection Paper is required",
            validate: (file) => {
              if (!file) return true;
              const MAX_SIZE = 1 * 1024 * 1024;
              if (file.size > MAX_SIZE) return "File size must be 1 MB or less";
              return true;
            },
          }}
          control={control}
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <FileUploader
              name="inspectionPaper"
              classNameMain=" "
              extraParentClasses="col-span-3"
              title="Upload Inspection Paper"
              message="Upload only Pdf format only less then 1 Mb"
              img="/img/upload-img.png"
              classNameImgDiv="flex flex-col items-center justify-center"
              fileVal={value}
              setFileVal={onChange}
              accept="application/pdf"
              showPreview={true}
              error={error}
              required
            />
          )}
        />
      </div>
    </div>
  );
};
export default AssignModal;
